export default __webpack_public_path__ + "static/media/elo.a4ed634a.svg";